import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { GET, POST, PUT, httpOk } from 'helpers/api'
import { formatDate } from 'helpers/helpers'

// Davomat sozlamalari — barcha ulash qadamlari bitta joyda.
// 2 usul birga ishlaydi: terminal (Face ID) va telegram (web). Har xodimga usul biriktiriladi.
function Index() {
	const { t } = useTranslation()
	const navigate = useNavigate()

	const [data, setData] = useState({ hikvision: { list: [] }, telegram: {}, employees: [] })
	const [copied, setCopied] = useState(null)
	const [busy, setBusy] = useState(null) // qaysi xodim qurilmaga yuborilyapti

	function webhookUrl(token) {
		const base = process.env.REACT_APP_API_URL
			|| (window.location.hostname === 'localhost' ? 'http://127.0.0.1:8000/api' : 'https://backend.tameer.uz/api')
		return base + '/hik/event/' + token
	}

	function copyUrl(token, id) {
		navigator.clipboard.writeText(webhookUrl(token))
		setCopied(id)
		setTimeout(() => setCopied(null), 1500)
	}

	async function getData() {
		const response = await GET('/attendance-setup', {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	async function setMethod(employeeId, method) {
		const response = await PUT('/attendance-setup/employee-method', { employee_id: employeeId, method }, { loader: false })
		if (httpOk(response)) {
			setData({
				...data,
				employees: data.employees.map((e) => (e.id === employeeId ? { ...e, attendance_method: method } : e)),
			})
		}
	}

	// Xodimni terminalga yuborish — ism + rasm ISAPI orqali qurilmaga yoziladi.
	// Qurilma bir nechta bo'lsa birinchisiga yuboriladi (odatda bitta bo'ladi).
	async function enroll(employee) {
		const device = (data.hikvision?.list || [])[0]
		if (!device) return

		setBusy(employee.id)
		const response = await POST('/hikvision-enroll',
			{ employee_id: employee.id, device_id: device.id }, { loader: false })
		setBusy(null)

		if (httpOk(response)) getData()
	}

	async function unenroll(employee) {
		const device = (data.hikvision?.list || [])[0]
		if (!device) return

		setBusy(employee.id)
		const response = await PUT('/hikvision-unenroll',
			{ employee_id: employee.id, device_id: device.id }, { loader: false })
		setBusy(null)

		if (httpOk(response)) getData()
	}

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	// Bosqich holati: yashil = tayyor, sariq = qolgan
	function stepBadge(ok, okText, noText) {
		return ok
			? <span className="badge bg-success">{okText}</span>
			: <span className="badge bg-warning text-dark">{noText}</span>
	}

	const hik = data.hikvision || { list: [] }
	const tg = data.telegram || {}
	const geoOk = !!(tg.work_lat && tg.work_lng)

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">{t('attendance_setup')}</h4>
			</div>

			<p className="text-muted" style={{ fontSize: '13.5px' }}>{t('attendance_setup_hint')}</p>

			<div className="row g-3">
				{/* ==== KARTA 1: HIKVISION TERMINAL ==== */}
				<div className="col-lg-6">
					<div className="card h-100">
						<div className="card-body">
							<h6 className="fw-bold mb-1">
								<i className="uil-camera me-1"></i>{t('method_terminal')}
							</h6>
							<p className="text-muted" style={{ fontSize: '12.5px' }}>{t('method_terminal_hint')}</p>

							<div className="d-flex flex-column gap-2 mb-3" style={{ fontSize: '13.5px' }}>
								<div className="d-flex justify-content-between">
									<span>1. {t('device_added')}</span>
									{stepBadge(hik.devices > 0, hik.devices + ' ' + t('pcs'), t('not_done'))}
								</div>
								<div className="d-flex justify-content-between">
									<span>2. {t('url_in_device')}</span>
									{stepBadge(!!hik.last_event_at, t('done'), t('waiting'))}
								</div>
								<div className="d-flex justify-content-between">
									<span>3. {t('persons_linked')}</span>
									{stepBadge(hik.unmatched === 0, t('done'), hik.unmatched + ' ' + t('remaining'))}
								</div>
							</div>

							{hik.list.map((d) => (
								<div key={d.id} className="border rounded p-2 mb-2" style={{ background: '#f7f7fb' }}>
									<div className="fw-600" style={{ fontSize: '13px' }}>{d.name}</div>
									<div className="d-flex align-items-center gap-1 mt-1">
										<code style={{ fontSize: '10.5px', wordBreak: 'break-all' }}>{webhookUrl(d.token)}</code>
										<button className="btn btn-sm btn-outline-secondary py-0 px-1" style={{ fontSize: '10px' }}
											onClick={() => copyUrl(d.token, d.id)}>
											{copied === d.id ? '✓' : t('copy')}
										</button>
									</div>
								</div>
							))}

							{hik.last_event_at &&
								<div className="text-muted" style={{ fontSize: '12px' }}>
									{t('last_event')}: {formatDate(hik.last_event_at, 'dd.MM.yyyy HH:mm')}
								</div>
							}

							<button className="btn btn-sm btn-outline-primary mt-2"
								onClick={() => navigate('/hikvision-devices')}>
								{t('manage')}
							</button>
						</div>
					</div>
				</div>

				{/* ==== KARTA 2: TELEGRAM / WEB ==== */}
				<div className="col-lg-6">
					<div className="card h-100">
						<div className="card-body">
							<h6 className="fw-bold mb-1">
								<i className="uil-telegram-alt me-1"></i>{t('method_telegram')}
							</h6>
							<p className="text-muted" style={{ fontSize: '12.5px' }}>{t('method_telegram_hint')}</p>

							<div className="d-flex flex-column gap-2 mb-3" style={{ fontSize: '13.5px' }}>
								<div className="d-flex justify-content-between">
									<span>1. {t('bot_token')}</span>
									{stepBadge(tg.bot_token, t('done'), t('not_done'))}
								</div>
								<div className="d-flex justify-content-between">
									<span>2. {t('work_location')}</span>
									{stepBadge(geoOk, (tg.radius || 0) + ' m', t('not_done'))}
								</div>
							</div>

							<div className="d-flex gap-2">
								<button className="btn btn-sm btn-outline-primary"
									onClick={() => navigate('/telegram-settings')}>
									{t('bot_token')}
								</button>
								<button className="btn btn-sm btn-outline-primary"
									onClick={() => navigate('/attendance')}>
									{t('work_location')}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* ==== KARTA 3: XODIMLAR USULI ==== */}
			<div className="card mt-3">
				<div className="card-body">
					<h6 className="fw-bold mb-1">{t('employee_methods')}</h6>
					<p className="text-muted" style={{ fontSize: '12.5px' }}>{t('employee_methods_hint')}</p>

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ minWidth: '33px' }}>#</th>
									<th style={{ width: '26%' }}>{t('name')}</th>
									<th style={{ width: '14%' }}>{t('phone')}</th>
									<th style={{ width: '16%' }} className="text-center">{t('linked')}</th>
									<th style={{ width: '20%' }}>{t('method')}</th>
									<th style={{ width: '23%' }} className="text-center">{t('terminal')}</th>
								</tr>
							</thead>
							<tbody>
								{data.employees.map((e, i) => (
									<tr key={e.id}>
										<td>{i + 1}</td>
										<td className="fw-600">{e.name}</td>
										<td>{e.phone || '—'}</td>
										<td className="text-center">
											{e.hikvision_person_id &&
												<span className="badge bg-info me-1" style={{ fontSize: '10.5px' }}>Face ID</span>}
											{e.telegram_id &&
												<span className="badge bg-primary" style={{ fontSize: '10.5px' }}>Telegram</span>}
											{!e.hikvision_person_id && !e.telegram_id &&
												<span className="text-muted">—</span>}
										</td>
										<td>
											<select className="form-select form-select-sm"
												value={e.attendance_method || 'manual'}
												onChange={(ev) => setMethod(e.id, ev.target.value)}>
												<option value="manual">{t('method_manual')}</option>
												<option value="terminal">{t('method_terminal')}</option>
												<option value="telegram">{t('method_telegram')}</option>
											</select>
										</td>

										{/* Terminalga yuborish — ism va rasm ISAPI orqali qurilmaga yoziladi */}
										<td className="text-center">
											{(data.hikvision?.list || []).length === 0
												? <span className="text-muted" style={{ fontSize: '12px' }}>{t('no_device')}</span>
												: e.face_enrolled
													? <div className="d-flex align-items-center justify-content-center gap-1">
														<span className="badge bg-success" style={{ fontSize: '10.5px' }}>{t('sent')}</span>
														<button className="btn btn-sm btn-outline-danger py-0 px-1" style={{ fontSize: '11px' }}
															disabled={busy === e.id} onClick={() => unenroll(e)}>
															{t('remove')}
														</button>
													</div>
													: !e.has_photo
														? <span className="text-muted" style={{ fontSize: '12px' }}>{t('no_photo')}</span>
														: <button className="btn btn-sm btn-outline-primary py-0 px-2" style={{ fontSize: '11.5px' }}
															disabled={busy === e.id} onClick={() => enroll(e)}>
															{busy === e.id ? '...' : t('send_to_terminal')}
														</button>
											}
										</td>
									</tr>
								))}
								{data.employees.length === 0 &&
									<tr><td colSpan="6" className="text-center text-muted py-4">{t('list_empty')}</td></tr>
								}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</>
	)
}

export default Index
